/* DS Wood — product card gallery navigation */
(function () {
  'use strict';

  function bind(root) {
    root.querySelectorAll('[data-card-gallery].card-gallery--multi').forEach(function (gallery) {
      if (gallery.dataset.galleryBound === '1') return;
      gallery.dataset.galleryBound = '1';

      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-card-slide]'));
      var prev = gallery.querySelector('[data-card-prev]');
      var next = gallery.querySelector('[data-card-next]');
      if (!slides.length || !prev || !next) return;

      var index = 0;
      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          s.classList.toggle('is-active', idx === index);
          s.setAttribute('aria-hidden', idx === index ? 'false' : 'true');
        });
      }

      function nav(delta) {
        return function (e) {
          e.preventDefault();
          e.stopPropagation();
          show(index + delta);
        };
      }

      prev.addEventListener('click', nav(-1));
      next.addEventListener('click', nav(1));
    });
  }

  function init() { bind(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
